module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "zk-notification-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "zk-notification",
    style: ({
      top: _vm.top ? _vm.top + 'px' : 'auto'
    }),
    on: {
      "mouseenter": function($event) {
        _vm.clearTimer()
      },
      "mouseleave": function($event) {
        _vm.startTimer()
      }
    }
  }, [(_vm.type) ? _c('i', {
    staticClass: "zk-notification__icon",
    class: [_vm.typeClass]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zk-notification__group",
    style: ({
      'margin-left': _vm.typeClass ? '55px' : '0'
    })
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
    staticClass: "zk-notification__closeBtn zk-icon-close",
    on: {
      "click": function($event) {
        _vm.handleClose()
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-43bef2c2"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/notification/src/notification.vue
// module id = 250
// module chunks = 0